<template>
  <section
    v-if="($store.state.events.eventExpenses.status === 'loading'
      || $store.state.events.eventStatus === 'loading')
      && ($store.state.events.updateTransactionsStatus !== 'success')"
    class="my-share-panel no-transaction">
    <app-loader
      class="loader"
    />
  </section>
  <section
    v-else-if="(operations && operations.length)
      || ($store.state.events.updateTransactionsStatus === 'success')"
    class="my-share-panel">
    <transaction
      :enable-transition="isComponentLoaded"
      :ref="transaction.operation.id === operations[operations.length - 1].operation.id
        ? 'lastTransactionRef' : null"
      @ready="onTransactionReady"
      v-for="(transaction, index) in operations"
      :key="transaction.id"
      :transaction="transaction.operation"
      :event-transactions="onlyOperationList"
      :user-expenses="transaction.user_expenses"
      :user="user"
      :event-contacts="eventContacts"
      :show-date-time="isDateTimeShown(transaction.operation, index)"
      position="right"/>
    <div
      class="event-info"
    >
      <span
        v-if="totalExpenses && !Array.isArray(totalExpenses)"
        class="my-share"
      >
        {{ $t('CP.myShare') }}:
        <span class="my-share__money">
          {{ totalExpenses }} <span class="my-share__currency">{{ eventCurrency }}</span>
        </span>
      </span>
      <span
        v-else-if="totalExpenses && Array.isArray(totalExpenses)"
        class="my-share"
      >
        {{ $t('CP.myShare') }}:
        <span
          class="my-share__money"
          v-for="(expense, index) of totalExpenses"
          :key="`${expense.currency}${index}`"
        >
          {{ expense.amount }}&nbsp;
          <span class="my-share__currency">
            {{ expense.currency }}{{ totalExpenses.length - 1 === index ? '.' : ',' }}
          </span>
        </span>
      </span>
      <span
        v-if="avgExpenses && !Array.isArray(avgExpenses)"
        class="avg-expenses"
      >
        {{ $t('CP.averageExpensesPerDay') }}:
        <span class="avg-expenses__money">
          {{ avgExpenses }} <span class="avg-expenses__currency">{{ eventCurrency }}</span>
        </span>
      </span>
      <span
        v-else-if="avgExpenses && Array.isArray(avgExpenses)"
        class="avg-expenses"
      >
        {{ $t('CP.averageExpensesPerDay') }}:
        <span
          class="avg-expenses__money"
          v-for="(expense, index) of avgExpenses"
          :key="`${expense.currency}${index}`"
        >
          {{ expense.amount }}
          <span class="avg-expenses__currency">
            {{ expense.currency }}{{ avgExpenses.length - 1 === index ? '.' : ',' }}
          </span>
        </span>
      </span>
    </div>
  </section>
  <section v-else-if="!operations.length" class="my-share-panel no-transaction">
    <div class="no-transaction">
      <img src="../../assets/img/sad.svg" alt="" class="no-transaction__img">
      <p class="no-transaction__text">{{ $t('CP.noTransactionsYet') }}</p>
    </div>
  </section>
</template>

<script>
import {
  CLEAR_EVENT_EXPENSES_UPDATE_STATUS,
  CLEAR_OPERATIONS_UPDATE_STATUS,
} from '@/store/events/types';
import Transaction from '../Transaction/Transaction';
import AppLoader from '../AppLoader/AppLoader';

export default {
  name: 'MySharePanel',
  components: {
    AppLoader,
    Transaction,
  },
  props: {
    expenses: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    eventContacts: {
      type: Array,
      default: () => [],
    },
    eventCurrency: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isComponentLoaded: false,
    };
  },
  mounted() {
    this.isComponentLoaded = true;
  },
  beforeDestroy() {
    this.isComponentLoaded = false;
    this.$store.commit(CLEAR_OPERATIONS_UPDATE_STATUS);
    this.$store.commit(CLEAR_EVENT_EXPENSES_UPDATE_STATUS);
  },
  computed: {
    operations() {
      if (this.expenses && this.expenses.eventExpenses && this.expenses.eventExpenses.operations) {
        return this.expenses.eventExpenses.operations.filter((operation) => (
          operation.user_expenses !== 0
        ));
      }
      return [];
    },
    onlyOperationList() {
      if (this.operations) {
        return this.expenses.eventExpenses.operations.map((operation) => (
          operation.operation
        ));
      }
      return [];
    },
    avgExpenses() {
      if (this.expenses
        && this.expenses.eventExpenses
        && this.expenses.eventExpenses.avg_expenses) {
        return this.expenses.eventExpenses.avg_expenses;
      }
      return '';
    },
    totalExpenses() {
      if (this.expenses
        && this.expenses.eventExpenses
        && this.expenses.eventExpenses.total_expenses) {
        return this.expenses.eventExpenses.total_expenses;
      }
      return '';
    },
  },
  methods: {
    isDateTimeShown(transaction, index) {
      if (this.operations.length - 1 === index) return true;
      const transactionDate = this.$moment(`${transaction && transaction.cr_date}Z`);
      const nextTransactionDate = this.$moment(`${(this.operations && this.operations[index + 1]
        && this.operations[index + 1].operation && this.operations[index + 1].operation.cr_date)}Z`);
      return ((transactionDate.date() !== nextTransactionDate.date())
        || (transactionDate.month() !== nextTransactionDate.month()));
    },
    onTransactionReady() {
      if (this.$refs.lastTransactionRef) {
        if (this.$refs.lastTransactionRef.$el && this.$refs.lastTransactionRef.$el.scrollIntoView) {
          this.$refs.lastTransactionRef.$el.scrollIntoView({ behavior: 'auto' });
        } else if (this.$refs.lastTransactionRef[0] && this.$refs.lastTransactionRef[0].$el
        && this.$refs.lastTransactionRef[0].$el.scrollIntoView) {
          this.$refs.lastTransactionRef[0].$el.scrollIntoView({ behavior: 'auto' });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .my-share-panel {
    padding: 0 30px 20px;
    height: calc(100% - 63px - 130px - 0px);
    min-height: 162px;
    overflow-y: auto;
    max-width: 100vw;
  }
  .event-info {
    display: flex;
    flex-wrap: wrap;
    justify-items: flex-end;
    margin-top: 41px;
  }
  .my-share, .avg-expenses {
    flex: 1 0 100%;
    text-align: right;
  }
  .avg-expenses {
    color: var(--text-seccond-color);
    font-size: 12px;
  }
  .avg-expenses__money {
    color: var(--btn-primary);
  }
  .avg-expenses__currency {
    font-size: 11px;
  }
  .my-share__money {
    color: var(--btn-primary);
    font-size: 16px;
  }
  .my-share__currency {
    font-size: 14px;
  }
  .no-transaction {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loader {
    margin: auto;
  }
  .no-transaction__img {
    width: 73px;
    height: 52px;
  }
  .no-transaction__text {
    color: #303F9F;
    opacity: 0.2;
    margin-bottom: 0;
  }
  @media screen and (max-width: $breakpoint-sm) {
    .my-share-panel {
      height: calc(100% - 63px - 130px - 0px);
      /*padding-bottom: 25vh;*/
    }
  }
</style>
